var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.898 7.2v2.4h7.2V7.2a3.6 3.6 0 0 0-7.2 0m-1.2 2.4V7.2a4.8 4.8 0 1 1 9.6 0v2.4h3.6v12h-16.8v-12zm-2.4 10.8h14.4v-9.6h-14.4z"
  })));
};
export default SvgLock;